const initialState = {
  budgetOrAuthorizationTypes: [],
  cbpList: [],
};
export default initialState;
